import { Box } from "@material-ui/core";
import React from "react";
import { Severity } from "../../../interfaces/enums/Severity";
import Button from "../../Forms/Button/Button";
import Alert from "../Alert";

type AlertOldVersionProps = {
    isLatestVersion: boolean;
    onClick?: () => void;
    className?: string;
};

const AlertOldVersion: React.FC<AlertOldVersionProps> = (props) => {
    const { isLatestVersion, onClick, className } = props;

    if (isLatestVersion) {
        return null;
    }

    return (
        <React.Fragment>
            <Alert severity={Severity.Error} className={className}>
                <div>
                    This quote is out of date, and might not be accurately reflected the
                    settings you have chosen.
                </div>
                {onClick && (
                    <Box>
                        <Button
                            variant="default"
                            size="m"
                            component="button"
                            onClick={onClick}>
                            Review settings
                        </Button>
                    </Box>
                )}
            </Alert>
        </React.Fragment>
    );
};

export default AlertOldVersion;
